import React, { Component } from 'react';
import { Modal, Tree, Spin, Button, notification } from 'antd';

const { DirectoryTree } = Tree;

export default class SelectGoogleDriveRootFolderDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedElement: undefined,
      folders: this.parseChildrenTotreeData(this.props.children),
      loading: false,
    };
  }

  getChildren = async (id) => {
    return await this.props.getChildren({ id, excludeFiles: true });
  };

  parseChildrenTotreeData = (children) => {
    if (children) {
      return children.map((child, index) => {
        return {
          key: child.id,
          title: child.shared ? `${child.name} (Shared)` : child.name,
          children: undefined,
        };
      });
    }
  };

  handleSubmitSave = () => {
    this.setState({ loading: true });

    this.props.assignRootFolderExternalId(this.state.selectedElement).then(() => {
      this.notify('Root folder successfully assigned.');
      typeof this.props.collbackGetExternalIdAndNavigateToDir === 'function'
        ? this.props.collbackGetExternalIdAndNavigateToDir()
        : this.props.refresh();
      this.props.onHide();
    });
  };

  onSelect = (keys, info) => {
    this.setState({ selectedElement: info.node.key });
  };

  onExpand = async (keys, info) => {
    if (info.expanded) {
      this.setState({ loading: true });

      const childFolreds = await this.props.getChildren({
        id: info.node.key,
        excludeFiles: true,
      });

      let folders = this.state.folders.slice();

      this.setChildren(folders, childFolreds, info.node.key);

      this.setState({ folders, loading: false });
    }
  };

  setChildren = (folders, childFolreds, key) => {
    for (let i in folders) {
      if (folders[i].key == key) {
        if (!folders[i].children) {
          folders[i].children = this.parseChildrenTotreeData(childFolreds);
        }

        return true;
      } else if (folders[i].children) {
        if (this.setChildren(folders[i].children, childFolreds, key)) {
          return true;
        }
      }
    }
  };

  notify = (description) => {
    notification.success({
      message: 'Success',
      top: 55,
      duration: 10,
      getContainer: this.props.rootContainer,
      description: description,
    });
  };

  closeHandler = () => {
    const { onHide, refresh } = this.props;

    refresh();
    onHide();
  };

  render() {
    const { rootContainer } = this.props;
    const { folders, loading } = this.state;

    return (
      <Modal
        title="Select root folder"
        getContainer={rootContainer}
        width="500px"
        open={true}
        onCancel={this.closeHandler}
        footer={[
          <Button key="back" onClick={this.closeHandler}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={this.handleSubmitSave} loading={loading} disabled={!this.state.selectedElement}>
            Submit
          </Button>,
        ]}
      >
        <Spin spinning={loading}>
          <DirectoryTree
            rootStyle={{
              maxHeight: '300px',
              overflowY: 'scroll',
            }}
            onSelect={this.onSelect}
            onExpand={this.onExpand}
            treeData={folders}
          />
        </Spin>
      </Modal>
    );
  }
}
